/**
 * Document Knowledge registry — the single lookup point for what every
 * document type IS. One definition file per document; this module only
 * assembles, validates, and indexes them.
 *
 * Definitions are validated at load so a malformed one fails loudly in
 * development instead of surfacing as a half-rendered panel.
 */

import { validateDefinition } from './schema';

import instagramPost from './definitions/instagramPost';
import instagramStory from './definitions/instagramStory';
import facebookPost from './definitions/facebookPost';
import meme from './definitions/meme';
import youtubeThumbnail from './definitions/youtubeThumbnail';
import youtubeBanner from './definitions/youtubeBanner';
import flyer from './definitions/flyer';
import poster from './definitions/poster';
import brochure from './definitions/brochure';
import pamphlet from './definitions/pamphlet';
import menu from './definitions/menu';
import logo from './definitions/logo';
import businessCard from './definitions/businessCard';
import presentation from './definitions/presentation';
import infographic from './definitions/infographic';
import invitation from './definitions/invitation';
import certificate from './definitions/certificate';
import giftCertificate from './definitions/giftCertificate';
import banner from './definitions/banner';
import emailHeader from './definitions/emailHeader';
import biodata from './definitions/biodata';
import other from './definitions/other';

const ALL_DEFINITIONS = [
  instagramPost, instagramStory, facebookPost, meme,
  youtubeThumbnail, youtubeBanner, flyer, poster,
  brochure, pamphlet, menu, logo,
  businessCard, presentation, infographic, invitation,
  certificate, giftCertificate, banner, emailHeader,
  biodata, other,
];

ALL_DEFINITIONS.forEach((def) => {
  const { valid, errors } = validateDefinition(def);
  if (!valid) {
    throw new Error(`Invalid document definition "${def?.id}": ${errors.join('; ')}`);
  }
});

const byId = new Map(ALL_DEFINITIONS.map((d) => [d.id, d]));
const byName = new Map(ALL_DEFINITIONS.map((d) => [d.name, d]));

export const listDocumentKnowledge = () => [...ALL_DEFINITIONS];

export const getDocumentKnowledge = (id) => byId.get(id) || null;

/** Lookup by display name — the value the Phase 1 dropdown carries. */
export const getDocumentKnowledgeByName = (name) => byName.get(name) || null;

export { CAPABILITIES, validateDefinition } from './schema';
